import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WarrantyServiceListing, WarrantyServiceListingResponseModel } from 'src/app/models/warrantyService/warrantyServiceListing.modal';
import { UrlHelperService } from 'src/app/services/Common/urlhelper.service';
import { ProductService } from 'src/app/services/product.service';
import { WarrantyServiceService } from 'src/app/services/warranty-service.service';


@Component({
  selector: 'app-warranty-service-listing',
  templateUrl: './warranty-service-listing.component.html',
  styleUrls: ['./warranty-service-listing.component.css']
})
export class WarrantyServiceListingComponent implements OnInit {
  warrantyServiceListing: WarrantyServiceListing;
  Loader: boolean = false;

  constructor(private urlHelperService: UrlHelperService, private _warrantyServiceService: WarrantyServiceService, private router: Router) {
    this.warrantyServiceListing = new WarrantyServiceListing();
  }

  ngOnInit() {
    this.WarrantyServiceList();
  }
  WarrantyServiceList() {
    this.Loader = true;
    this._warrantyServiceService.WarrantyServiceListing()
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.Loader = false;
          this.warrantyServiceListing.WarrantyServiceList = responseBody.responseData;
        }
        (err) => {
          this.Loader = false;
        }
      });
  }
  WarrantyServicedetails(productDetail) {
    this.router.navigate(['/warranty-service-update/' + productDetail.id]);
  }
}
